import type { Language } from './language'

type ContactLabels = Record<string, string>

export const ERROR_MESSAGES: Record<Language, ContactLabels> = {
  th: {
    required: 'กรุณากรอก {label}',
    email: 'อีเมล ต้องเป็นรูปแบบอีเมล',
    phone: 'เบอร์โทรศัพท์ ต้องเป็นตัวเลขจำนวน 9-10 ตัวเท่านั้น',
  },
  en: {
    required: 'Please enter {label}',
    email: 'Email must be in a valid email format',
    phone: 'Phone number must be digits only, 9-10 characters',
  },
  zh: {
    required: '请输入{label}',
    email: '电子邮件必须为有效的邮件格式',
    phone: '电话号码必须为数字，限9-10位',
  },
  kr: {
    required: '{label} 입력해 주세요',
    email: '이메일은 올바른 이메일 형식이어야 합니다',
    phone: '전화번호는 숫자만 가능하며 9-10자리여야 합니다',
  },
  jp: {
    required: '{label}を入力してください',
    email: 'メールはメール形式で入力してください',
    phone: '電話番号は数字のみ、9〜10桁で入力してください',
  },
}

export const HEADER_INPUT: Record<Language, ContactLabels> = {
  th: {
    name: 'ชื่อ-นามสกุล',
    tel: 'เบอร์โทรศัพท์',
    email: 'อีเมล',
    subject: 'หัวข้อ',
    detail: 'รายละเอียดเพิ่มเติม',
  },
  en: {
    name: 'Full Name',
    tel: 'Phone Number',
    email: 'Email',
    subject: 'Subject',
    detail: 'Additional Details',
  },
  zh: {
    name: '姓名',
    tel: '电话号码',
    email: '电子邮件',
    subject: '主题',
    detail: '详细信息',
  },
  kr: {
    name: '이름',
    tel: '전화번호',
    email: '이메일',
    subject: '제목',
    detail: '상세 내용',
  },
  jp: {
    name: '氏名',
    tel: '電話番号',
    email: 'メール',
    subject: '件名',
    detail: '詳細',
  },
}

export const HEADER_CONTACT: Record<Language, ContactLabels> = {
  th: {
    address: 'ที่อยู่ :',
    phone: 'เบอร์โทร :',
    line: 'LINE ID :',
    email: 'อีเมล :',
  },
  en: {
    address: 'Address :',
    phone: 'Phone :',
    line: 'LINE ID :',
    email: 'Email :',
  },
  zh: {
    address: '地址 :',
    phone: '电话 :',
    line: 'LINE ID :',
    email: '电子邮件 :',
  },
  kr: {
    address: '주소 :',
    phone: '전화 :',
    line: 'LINE ID :',
    email: '이메일 :',
  },
  jp: {
    address: '住所 :',
    phone: '電話 :',
    line: 'LINE ID :',
    email: 'メール :',
  },
}
